import { type GetShipmentsParams, getShipments } from '@uturn/api/v2';
import { create } from 'zustand';
import { type MultiSelectShipmentStore, type ShipmentState } from './type';

/** @deprecated */
const defaultFilters: GetShipmentsParams = {
	// viewType: 'ASSIGNED',
};

/** @deprecated */
export const useAssignedShipmentStore = create<
	MultiSelectShipmentStore & ShipmentState
>((set, get) => ({
	shipments: [[]],
	isLoaded: false,
	multiSelect: false,
	totalShipments: 0,
	page: 0,
	pageLimit: 1,
	pageSize: 60,
	filters: defaultFilters,
	setMultiSelect: (state) => {
		set({ multiSelect: state });
	},
	fetch: async (page?: number) => {
		const currentPage = page || get().page;

		const { data } = await getShipments({
			...get().filters,
			page: currentPage.toString(),
		});

		const shipment = data.data || [];
		const newShipment = get().shipments;
		const totalElements = data.totalElements || 0;

		newShipment[currentPage] = shipment as any;

		set({
			shipments: newShipment,
			totalShipments: data.totalElements,
			page: currentPage,
			pageLimit: Math.ceil(totalElements / get().pageSize),
			isLoaded: true,
		});
	},
	setPage: (page: number) => {
		const { pageLimit, shipments } = get();

		if (page > pageLimit || page < 0) {
			return;
		}

		shipments[page] = shipments[page] || [];

		set({ page, isLoaded: false, shipments });
		get().fetch(page);
	},
	setFilters: (filters: Partial<GetShipmentsParams>) => {
		set({ filters: { ...defaultFilters, ...filters } });
		get().fetch();
	},
}));
